export default __webpack_public_path__ + "static/media/estorrent.485b6eb5.jpg";